import { Component, HostListener, Input } from '@angular/core';

@Component({
    selector: 'app-selectable-card',
    templateUrl: './selectable-card.component.html',
    styleUrls: ['./selectable-card.component.scss'],
    standalone: false
})

export class SelectableCardComponent {
  @Input() public text: string;
  @Input() public selected = false;
  @Input() public wider = false;
  @Input() public toggleMode = true;

  @HostListener('click') public onClick(): void {
    if (this.toggleMode) {
      this.selected = !this.selected;
    }
  }
}
